export default __webpack_public_path__ + "static/media/chart-upward.ef77244a.svg";